import { CONSENT_CATEGORY } from 'config/types/consent'
import { SDKScriptJSON } from 'config/types/codegen'
import { SDKScripts } from '../generated/types'
import SDKScriptsRecord from '../generated/SDKScripts.json'

const scriptPolicies = SDKScriptsRecord as SDKScriptJSON
const CONSENT_ATTRIBUTE = 'data-cookiecategory'

type ScriptAttributeResponse = [
  attribute: typeof CONSENT_ATTRIBUTE,
  category: CONSENT_CATEGORY | undefined,
]

export class Scripts {
  getConsentAttribute(script: SDKScripts): ScriptAttributeResponse {
    const category = this.getScriptCategory(script)

    return [CONSENT_ATTRIBUTE, category]
  }

  protected getScriptCategory(script: SDKScripts) {
    const category = scriptPolicies[script]?.category
    if (!category) {
      this.logScriptPolicyError(script)
    }

    return category
  }

  private logScriptPolicyError(script: string) {
    console.error(
      `@gousto-internal/storage-consent-web-package: Consent policy for script ${script} not found.`,
    )
  }
}

export const scripts = new Scripts()
